import React from 'react';
import './Features.css';
import { assets } from '../../assets/assets';

const serviceCards = [
  {
    icon: 'shield',
    title: 'WARRANTY ASSURED',
    description: 'In case of faulty products, we have an upstanding warranty and claim procedures to make sure that your requirements are met in minimum time loss as possible.'
  },
  {
    icon: 'gears',
    title: 'CUSTOM ORDERS',
    description: 'In case your requirements supersedes what the local market has to offer, we will provide you with assistance to meet these requirements'
  },
  {
    icon: 'truck',
    title: 'HOME DELIVERY',
    description: 'To further facilitate your access to your needs, we offer to deliver to meet your requirements straight to where you live within Sri Lankan Borders'
  }
];

const Features = () => {
  return (
    <div className='features-section-wrapper'>
      <div className="features-service-cards-grid">
        {serviceCards.map((card, index) => (
          <div key={index} className="features-service-card-item">
            <div className="features-service-icon-container">
              {card.icon === 'shield' && <img src={assets.icon3} alt="Shield" className="features-service-icon-image" />}
              {card.icon === 'gears' && <img src={assets.icon2} alt="Gears" className="features-service-icon-image" />}
              {card.icon === 'truck' && <img src={assets.icon1} alt="Truck" className="features-service-icon-image" />}
            </div>
            <h2 className="features-service-card-title">{card.title}</h2>
            <p className="features-service-card-description">{card.description}</p>
            <div className="features-service-card-footer">*Conditions Applied</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Features;